import React, { useContext, useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Select from "react-select"
import { useNavigate } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import {
  numberFormat,
  getTodayDate,
  getType,
  selectDropdownStyle,
  dateFormat,
} from "../../../Helpers/Utils/Common"
import DatePicker from "react-datepicker"
import Moment from "moment"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import * as XLSX from "xlsx"

import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches"
import { getAllProducts } from "./../../../Helpers/apiCalls/Manage/Products"
import {
  getSalesPerProduct,
  getSalesPerProductPotato,
} from "./../../../Helpers/apiCalls/Reports/DailyOrdersApi"
import { searchItem } from "../../../Helpers/apiCalls/itemsApi"
import { getCategory } from "../../../Helpers/apiCalls/categoryApi"
import TotalSales from "../../OfficeReports/TotalSales/TotalSales"
import Footer from "../../../Components/Footer/Footer"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function WholesaleTopSellingPrice() {
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)
  const [inactive, setInactive] = useState(true)
  const today = Moment().format("MM/DD/YYYY")
  const [filterConfig, setFilterConfig] = useState({
    date_from: dateFilter.date_from ? dateFilter.date_from : today,
    date_to: dateFilter.date_to ? dateFilter.date_to : today,
  })
  const [showLoader, setShowLoader] = useState(false)
  const [allData, setAllData] = useState([])
  const [items, setItems] = useState([])
  const [categories, setCategories] = useState([])
  const [excelData, setExcelData] = useState([])
  const [summary, setSummary] = useState([])

  const xlsxHeaders = [
    "ITEM NAME",
    "QUANTITY",
    "SUBTOTAL",
    "DISCOUNT",
    "TOTAL SALES",
  ]

  // async function fetchBranches() {
  //     setBranches([])

  //     const response = await getAllBranches();
  //     if (response.error) {
  //     } else {
  //         var allBranches = response.data.data.data
  //         .filter((data) => { return (data.is_franchise !== "3" && data.is_franchise !== "1")})
  //         .map((data) => {
  //             var branch = data;
  //             branch.label = data.name
  //             branch.value = data.id
  //             return branch;
  //         });
  //         setBranches([{label: "All Branches", value:""}, ...allBranches]);
  //     }
  // }

  async function fetchItems() {
    setItems([])
    const response = await searchItem({})

    if (response.response) {
      var data = response.response.data.map((item) => {
        var info = item
        info.label = item.name
        info.value = item.id
        return info
      })
      setItems([{ label: "All Products", value: "" }, ...data])
    }
  }

  async function fetchCategories() {
    setCategories([])
    const response = await getCategory({})
    if (response.data) {
      //categories
      var categories = response.data.data.map((category) => {
        var info = {}
        info.value = category.id
        info.label = category.name
        info.id = category.id
        // info.selected_value_name = "selected_category"
        return info
      })
      setCategories(categories)
    }
  }

  async function fetchData() {
    setShowLoader(true)
    setAllData([])
    setExcelData([])
    // setTotalRevenue(0)
    // setTotalCost(0)
    // setTotalProfit(0)
    // setTotalDiscount(0)
    console.log(filterConfig)
    const response = await getSalesPerProduct(filterConfig)
    if (response.error) {
    } else {
      setSummary(response.data.summary)
      var allItems = response.data.data.map((bill) => {
        var info = bill
        info.subtotal = numberFormat(info.subtotal)
        info.total_sales = numberFormat(info.total_sales)
        info.discount = numberFormat(info.discount)
        return info
      })
      setAllData(allItems)
      setExcelData(allItems)
    }
    setShowLoader(false)
  }

  // const handleTabSelect = (tabKey) => {
  //   setFilterConfig((prev) => {
  //     return {
  //       ...prev,
  //       tab: tabKey,
  //       product_id: "",
  //       branch_id: "",
  //       date_from: "",
  //       date_to: "",
  //     }
  //   })
  // }

  function handleExport() {
    const rows = excelData
    const header = ["", ""]
    const meta = [
      ["REPORT TITLE:", "RETAIL TOP SELLING PRICE"],
      [
        "ITEM:",
        filterConfig.item_name !== "" && filterConfig.item_name !== undefined
          ? filterConfig.item_name
          : "All Items",
      ],
      [
        "BRANCH:",
        filterConfig.branch_name !== "" &&
        filterConfig.branch_name !== undefined
          ? filterConfig.branch_name
          : "All Branches",
      ],
      [
        "CATEGORY:",
        filterConfig.category_name !== "" &&
        filterConfig.category_name !== undefined
          ? filterConfig.category_name
          : "All Categories",
      ],
      [
        "DATE FROM:",
        filterConfig.date_from !== "" && filterConfig.date_from !== undefined
          ? dateFormat(filterConfig.date_from)
          : "N/A",
      ],
      [
        "DATE TO:",
        filterConfig.date_to !== "" && filterConfig.date_to !== undefined
          ? dateFormat(filterConfig.date_to)
          : "N/A",
      ],
      ["TOTAL QUANTITY:", summary.total_qty ? summary.total_qty : 0],
      ["TOTAL COST:", summary.total_cost ? summary.total_cost : 0],
      ["TOTAL DISCOUNT:", summary.total_discount ? summary.total_discount : 0],
      ["TOTAL SALES:", summary.total_sales ? summary.total_sales : 0],
    ]

    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: header,
    })

    /* generate worksheet and workbook */
    const workbook = XLSX.utils.book_new()
    XLSX.utils.sheet_add_json(sheet, rows, { origin: "A12" })
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" })
    XLSX.utils.sheet_add_aoa(sheet, [xlsxHeaders], { origin: "A12" })
    XLSX.writeFile(
      workbook,
      `WholesaleTopSellingItem (${Moment().format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    )
  }

  useEffect(() => {
    // fetchBranches();
    fetchItems()
    fetchCategories()
  }, [])

  useEffect(() => {
    fetchData()
  }, [filterConfig])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"SALES REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              TOP SELLING ITEM{" "}
            </h1>
          </Col>
        </Row>

        <div className="tab-content">
          {/* filters */}

          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Item"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: state.isSelected
                      ? "white"
                      : "var(--primary-color)",
                    borderRadius: "7px",
                    border: "0px",
                    minHeight: "20px",
                    maxHeight: "35px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    color: state.isSelected ? "white" : "white",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                  singleValue: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                  placeholder: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                }}
                options={items}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return { ...prev, item_id: e.value, item_name: e.label }
                  })
                }}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Category"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: state.isSelected
                      ? "white"
                      : "var(--primary-color)",
                    borderRadius: "7px",
                    border: "0px",
                    minHeight: "20px",
                    maxHeight: "35px",
                  }),
                  input: (baseStyles, state) => ({
                    ...baseStyles,
                    color: state.isSelected ? "white" : "white",
                  }),
                  dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                  singleValue: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                  placeholder: (baseStyles, state) => ({
                    ...baseStyles,
                    color: "white",
                  }),
                }}
                options={categories}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      category_id: e.value,
                      category_name: e.label,
                    }
                  })
                }}
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_from}
                name="date_from"
                placeholderText={today}
                onChange={(date) => {
                  setDateFrom(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormat="MMMM dd, yyyy"
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.date_to}
                name="date_to"
                placeholderText={today}
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                dateFormat="MMMM dd, yyyy"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className=" PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 mt-2 ps-label">
              Total Quantity: {summary.total_qty}
            </span>
            <span className="me-4 ml-4 mt-2 ps-label">
              Total Sales: {summary.total_sales}
            </span>
            <span className="me-4 ml-4 mt-2 ps-label">
              Total Discount: {summary.total_discount}
            </span>
          </div>

          <div className="below">
            {/* table */}
            <Table
              tableHeaders={[
                "ITEM",
                "QUANTITY",
                "SUBTOTAL",
                "DISCOUNT",
                "TOTAL SALES",
              ]}
              headerSelector={[
                "item_name",
                "total_qty",
                "subtotal",
                "discount",
                "total_sales",
              ]}
              tableData={allData}
              showLoader={showLoader}
            />
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
